import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
export function FinalCloseSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-25">
      <div className="max-w-3xl mx-auto text-center" data-id="element-26">
        <h2 className="font-playfair text-2xl md:text-4xl font-bold mb-10" data-id="element-27">
          Tienes <span className="text-[#d4a853]" data-id="element-28">dos opciones</span> en este
          momento:
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-29">
          {/* Option 1 - Bad */}
          <div className="bg-[#111111] border border-red-900/30 rounded-sm p-6 md:p-8 text-left" data-id="element-30">
            <div className="w-8 h-8 rounded-full border border-red-500/40 flex items-center justify-center mb-4" data-id="element-31">
              <span className="text-red-400 font-bold text-sm" data-id="element-32">1</span>
            </div>
            <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-33">
              Seguir haciendo lo mismo, ignorando el poder de la IA y viendo
              cómo tu alcance{' '}
              <span className="text-red-400" data-id="element-34">muere lentamente.</span>
            </p>
          </div>

          {/* Option 2 - Good */}
          <div className="bg-[#111111] border border-[#d4a853]/30 rounded-sm p-6 md:p-8 text-left" data-id="element-35">
            <div className="w-8 h-8 rounded-full border border-[#d4a853]/60 flex items-center justify-center mb-4" data-id="element-36">
              <span className="text-[#d4a853] font-bold text-sm" data-id="element-37">2</span>
            </div>
            <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-38">
              Invertir lo que cuesta una pizza, dominar la habilidad más
              demandada del 2026 y poner a tu marca{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-39">
                en el nivel de las élites.
              </span>
            </p>
          </div>
        </div>

        <p className="text-gray-400 text-base md:text-lg mb-8" data-id="element-40">
          La decisión es tuya. Haz clic abajo y empecemos.
        </p>

        <CTAButton text="ADQUIRIR ACCESO POR $11.99" data-id="element-41" />
      </div>
    </AnimatedSection>;
}